import styled from 'styled-components';
import { em } from 'polished';
import { colors, accessibilityBorder } from 'core/theme';
import { media } from 'core/layout';

export const StyledPopup = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;

  background-color: ${colors.B87A};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;

  pointer-events:none;
  overflow:hidden;

  & > div {
    height: 100%;
    display: flex;
    align-items: center;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 3rem;
  max-width: 920px;
  max-height: 100%;

  ${media.tablet`
    padding: 0;
  `};

  ${media.tabletSmall`
    margin: 0 -20px;
    width: calc(100% + 40px);
  `};
`;

export const TopBar = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  background-color: ${colors.secondary};
  padding: 0.5em 1em;
  
  & > button {
    pointer-events:auto;
    &,
    &:hover {
      color: ${colors.background};
    }

    &:hover > span:not(:first-child) {
      text-decoration: underline;
    }

    & > span:first-child {
      margin-right: 0.5em;
    }
  }

  ${media.mobile`
    padding: 0.25em 0.5em;
  `};
`;

export const Content = styled.div`
  flex: 1 1 auto;
  background-color: ${colors.background};
  overflow: auto;
  padding: ${em(60)} ${em(100)};
  position: relative;
  pointer-events:auto;

  & > * > * {
    &:first-child {
      margin-top: 0 !important;
    }

    &:last-child {
      margin-bottom: 0 ;
    }
  }

  ${accessibilityBorder};

  ${media.tablet`
    padding: ${em(30)} ${em(50)};
  `};

  ${media.tabletSmall`
    padding: 1.5em;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  `};

  ${media.mobile`
    padding: 1em;
  `};
`;



// WEBPACK FOOTER //
// ./src/modules/Popup/styled.js